import PropTypes from 'prop-types';

export const routerPropType = PropTypes.shape({
  back: PropTypes.func,
  currentPath: PropTypes.func,
  navigate: PropTypes.func,
  pop: PropTypes.func
});
